import * as React from "react";

export const OpenLocationSearchButton: React.FC<{
  onLocationSelection: () => void;
}> = (props) => {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault();
        props.onLocationSelection();
      }}
      className="prod-button"
      title="To ensure availability, a delivery location is required before adding to cart"
    >
      Select delivery location
    </button>
  );
};
